<template>
  <transition name="Cookies">
    <div class="Cookies">
      {{ trans('cookies') }}
      <div class="Cookies__close" @click="$store.commit('user/SET_COOKIE')">
        <img :src="require('./img/close.png')" />
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'Cookies',
  translations: {
    fr: {
      cookies: `
        Nous utilisons des témoins et d’autres technologies semblables pour
        comprendre comment les utilisateurs interagissent avec notre site Web,
        transmettre de l’information adaptée à vos intérêts et permettre le
        partage de contenu. En naviguant sur notre site Web, vous consentez
        à l’utilisation de témoins. Pour en apprendre plus à propos des témoins
        ou pour gérer vos préférences, veuillez lire notre Politique sur les témoins (« Cookies »).
      `
    },
    en: {
      cookies: `
        We use cookies and other similar technologies to measure
        the website audience, offer a better browsing experience,
        send personalized information and enable content sharing.
        By browsing the website, you accept the use of cookies.
        To learn more about cookies and/or manage your preferences,
        please read our cookie policy.
      `
    },
  }
}
</script>

<style lang="stylus">
@import '~@/config/Settings'

.Cookies
  position fixed
  bottom 0px
  padding 15px 30px 15px 15px
  color white
  background rgba(black, .8)
  font-weight 400
  left 0
  right 0
  font-size 9px
  transition opacity 1s
  line-height 14px
  z-index 999999
  color white
  &-enter
  &-leave-active
    opacity 0

  &__close
    position absolute
    top 0px
    right 0px
    padding 10px
    font-size 14px
    width 11px
    height 11px

</style>
